export const T = {
  en_GB: {
    statusOk: "Within bounds",
    statusAccepted: "Deviation accepted",
    statusNotAccepted: "Blocked by advisor",
    statusDeviation: "Breach",
    statusNotEvaluable: "Cannot evaluate",
    actual: "Actual",
    max: "Max",
    noCap: "No cap",
    ceilingChangedTo: (pct: string) =>
      `The risk model's ceiling for this score has since changed to ${pct}%. This completed session is judged against the ceiling in force when the decision was taken.`,
    ceilingDisabledSince:
      "Risk bounds have since been disabled on the risk model. This completed session is judged against the ceiling in force when the decision was taken.",
    // QL-371 — the "what to do next" line after the caller's breach message.
    breachAcceptHint:
      "Adjust the portfolios, or accept the deviation below with a justification to proceed.",
    breachBlockedHint:
      "The advice is blocked — adjust the portfolios, or change the decision below.",
    hardBlockMessage: "Deviation acceptance is disabled — adjust the portfolios to continue.",
  },
  nb_NO: {
    statusOk: "Innenfor grensene",
    statusAccepted: "Avvik akseptert",
    statusNotAccepted: "Blokkert av rådgiver",
    statusDeviation: "Brudd",
    statusNotEvaluable: "Kan ikke vurderes",
    actual: "Faktisk",
    max: "Maks",
    noCap: "Ingen grense",
    ceilingChangedTo: (pct: string) =>
      `Risikomodellens grense for denne scoren er siden endret til ${pct}%. Denne fullførte økten vurderes mot grensen som gjaldt da beslutningen ble tatt.`,
    ceilingDisabledSince:
      "Risikogrensene er siden deaktivert på risikomodellen. Denne fullførte økten vurderes mot grensen som gjaldt da beslutningen ble tatt.",
    breachAcceptHint:
      "Juster porteføljene, eller aksepter avviket nedenfor med en begrunnelse for å fortsette.",
    breachBlockedHint:
      "Rådgivningen er blokkert — juster porteføljene, eller endre beslutningen nedenfor.",
    hardBlockMessage: "Aksept av avvik er deaktivert — juster porteføljene for å fortsette.",
  },
} as const;
